"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenEnumerator = void 0;
const FracturedJsonError_1 = require("./FracturedJsonError");
/**
 * Provided .NET-like Enumerator semantics wrapped around a TypeScript Generator.
 */
class TokenEnumerator {
    constructor(generator) {
        this._generator = generator;
    }
    get Current() {
        if (!this._current)
            throw new FracturedJsonError_1.FracturedJsonError("Illegal enumerator usage");
        return this._current;
    }
    MoveNext() {
        const genItem = this._generator.next();
        this._current = genItem.value;
        return !genItem.done;
    }
}
exports.TokenEnumerator = TokenEnumerator;
